import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { helperTextSlot } from './slot.vanilla.mjs';

const HelperTextSlot = forwardRef(
  ({ className: classNameFromProps, ...props }, forwardedRef) => {
    const className = classNames(helperTextSlot, classNameFromProps);
    return /* @__PURE__ */ jsx(
      "div",
      {
        "data-scope": "helper-text",
        "data-part": "slot",
        className,
        ref: forwardedRef,
        ...props
      }
    );
  }
);
HelperTextSlot.displayName = "HelperText.Slot";

export { HelperTextSlot };
//# sourceMappingURL=Slot.mjs.map
